import type { SvgIconComponent } from '@mui/icons-material';
import {
  Home,
  Bungalow,
  Apartment,
  Domain,
  HolidayVillage,
  ViewModule,
  LocationCity,
  CorporateFare,
  Business,
  MapsHomeWork,
  Hub,
  Engineering,
  Landscape,
  Terrain,
  Park,
  // Legado (planos já salvos no banco)
  WorkspacePremium,
  BusinessCenter,
  Construction,
  Groups,
  AccountBalance
} from '@mui/icons-material';

export type PlanIconValue = string;

export interface PlanIconOption {
  value: PlanIconValue;
  label: string;
  Icon: SvgIconComponent;
  group: 'scale' | 'legacy';
}

/** Ordenado do menor para o maior volume / escala urbana */
export const PLAN_ICON_OPTIONS: PlanIconOption[] = [
  { value: 'Home', label: 'Unidade / casa — menor volume', Icon: Home, group: 'scale' },
  { value: 'Bungalow', label: 'Residencial baixa densidade', Icon: Bungalow, group: 'scale' },
  { value: 'Apartment', label: 'Prédio / bloco único', Icon: Apartment, group: 'scale' },
  { value: 'Domain', label: 'Condomínio (torres)', Icon: Domain, group: 'scale' },
  {
    value: 'HolidayVillage',
    label: 'Conjunto / vilas fechadas',
    Icon: HolidayVillage,
    group: 'scale'
  },
  { value: 'ViewModule', label: 'Vários blocos / quadras', Icon: ViewModule, group: 'scale' },
  { value: 'LocationCity', label: 'Bairro / cidade', Icon: LocationCity, group: 'scale' },
  {
    value: 'CorporateFare',
    label: 'Parque de edifícios / grande porte',
    Icon: CorporateFare,
    group: 'scale'
  },
  { value: 'Business', label: 'Torre / gestão corporativa', Icon: Business, group: 'scale' },
  {
    value: 'MapsHomeWork',
    label: 'Carteira ampla de condomínios',
    Icon: MapsHomeWork,
    group: 'scale'
  },
  { value: 'Hub', label: 'Rede / administradora (portfólio)', Icon: Hub, group: 'scale' },
  { value: 'Engineering', label: 'Urbanização / loteamento', Icon: Engineering, group: 'scale' },
  { value: 'Landscape', label: 'Área em expansão', Icon: Landscape, group: 'scale' },
  { value: 'Terrain', label: 'Região / macro área', Icon: Terrain, group: 'scale' },
  { value: 'Park', label: 'Entorno arborizado', Icon: Park, group: 'scale' },
  { value: 'WorkspacePremium', label: 'Premium (legado)', Icon: WorkspacePremium, group: 'legacy' },
  { value: 'BusinessCenter', label: 'Escritório (legado)', Icon: BusinessCenter, group: 'legacy' },
  { value: 'Construction', label: 'Obras (legado)', Icon: Construction, group: 'legacy' },
  { value: 'Groups', label: 'Comunidade (legado)', Icon: Groups, group: 'legacy' },
  {
    value: 'AccountBalance',
    label: 'Institucional (legado)',
    Icon: AccountBalance,
    group: 'legacy'
  }
];

export const PLAN_ICON_MAP: Record<string, SvgIconComponent> = Object.fromEntries(
  PLAN_ICON_OPTIONS.map(o => [o.value, o.Icon])
);

export function resolvePlanIcon(iconName?: string | null): SvgIconComponent | null {
  if (!iconName?.trim()) return null;
  return PLAN_ICON_MAP[iconName.trim()] ?? null;
}
